/**
 *
 * @param {*} obj object to clean
 * @returns object without null / undefined / ""
 */
export default function cleanObject(obj) {
  const newObject = obj;
  const objectEntries = Object.keys(newObject);
  objectEntries.forEach((item) => {
    if (
      newObject[item] === null ||
      newObject[item] === undefined ||
      newObject[item] === "" ||
      newObject[item] === "null" ||
      (Array.isArray(newObject[item]) && !newObject[item].length)
    ) {
      delete newObject[item];
    }
  });
  return newObject;
}
